// extracted by mini-css-extract-plugin
export default {"file":"ProfUnionsViewConfirmDocument_file__v4psc","size":"ProfUnionsViewConfirmDocument_size__6CYw9"};